import type { Ref, RefCallback } from 'react';

export function useMergeRefs<T>(...refs: (Ref<T> | undefined)[]): RefCallback<T> {
  return (value) => {
    refs.forEach((ref) => {
      if (ref) {
        if (typeof ref === 'function') {
          ref(value);
        } else if (ref !== null) {
          ref.current = value;
        }
      }
    });
  };
}
